import schema from '@/framework/logic/schema/init-layout.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

const mapInitLayout = action => ({
  type: 'LAYOUT_SETUP',
  payload: {
    value: action.data,
  },
});

const initLayout = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapInitLayout(validated(interpolate(meta.action, event, context)));
};

export default initLayout;
